import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import type {
  EventMarketPeriodTypes,
  EventMarketType,
  EventRunnerType,
  EventType,
} from "app/types/eventType";
import { RunnerTypes } from "app/utils/const";
import { Component } from "react";
import { connect } from "react-redux";
import Away from "./components/Away/Away";
import Home from "./components/Home/Home";
import NA from "./components/NA/NA";
import "./HomeAwayNASides.scss";

type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: EventMarketPeriodTypes;
  addBetSlip: Function;
};

class HomeAwayNASides extends Component<Props> {
  addBetSlip = (runner: EventRunnerType) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  render() {
    const { event, market, marketType } = this.props;

    const homeRunnerMissing =
      market.runners.length === 1 &&
      market.runners[0]?.side === RunnerTypes.AWAY;

    let home: EventRunnerType[] = [];
    let away: EventRunnerType[] = [];
    let na: EventRunnerType[] = [];
    // need a better solution for this
    // there also seems to be a bug with runner updates BET-12802
    market &&
      market.runners.map(runner => {
        if (
          marketPeriodHelper.formatRunnerName(runner.side) === RunnerTypes.HOME
        ) {
          home.push(runner);
        } else if (
          marketPeriodHelper.formatRunnerName(runner.side) === RunnerTypes.AWAY
        ) {
          away.push(runner);
        } else if (
          marketPeriodHelper.formatRunnerName(runner.side) === RunnerTypes.NA ||
          marketPeriodHelper.formatRunnerName(runner.side) === RunnerTypes.DRAW
        ) {
          na.push(runner);
        }
      });

    return (
      <div
        className={`market home-and-away-na-sides ${
          event && event.sportType && event.sportType.toLowerCase()
        } ${market.status.toLowerCase()}`}
      >
        {homeRunnerMissing && (
          <span className={"home-and-away-sides__runner--empty"}></span>
        )}
        {/* Change order of display in css for boxing */}
        <Away
          away={away}
          event={event}
          market={market}
          marketType={marketType}
          addBetSlip={this.addBetSlip}
        />
        <Home
          home={home}
          event={event}
          market={market}
          marketType={marketType}
          addBetSlip={this.addBetSlip}
        />
        <NA
          na={na}
          event={event}
          market={market}
          marketType={marketType}
          addBetSlip={this.addBetSlip}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(null, mapDispatchToProps)(HomeAwayNASides) as any;
